import { useEffect, useState } from 'react';
import type { ReactNode } from 'react';
import { Accordion } from '@reach/accordion';
import type { SerializedStyles } from '@emotion/react';

interface AccordionContainerProps {
  onChange?: (value: number) => void;
  sectionToShow?: number;
  disableControl: boolean;
  children: ReactNode;
  customCss?: SerializedStyles;
}

/**
 * Please use the Hotsauce version instead
 * @deprecated
 */
export const AccordionContainer = ({
  onChange,
  children,
  sectionToShow = -1,
  disableControl = false,
  customCss,
}: AccordionContainerProps): JSX.Element => {
  const [openedSection, setOpenedSection] = useState<number>(sectionToShow);

  useEffect(() => {
    if (disableControl) {
      setOpenedSection(sectionToShow);
    }
  }, [sectionToShow, disableControl]);

  const toggleSection = (index: number) => {
    let newIndex = -1;
    if (openedSection !== index) {
      newIndex = index;
    }
    if (onChange) {
      onChange(newIndex);
    }
    if (!disableControl) {
      setOpenedSection(newIndex);
    }
  };

  return (
    <Accordion index={openedSection} onChange={toggleSection} css={customCss}>
      {children}
    </Accordion>
  );
};
